import classNames from 'classnames'
import { uniqueId } from 'lodash'
import PropTypes from 'prop-types'
import React from 'react'

import Field from 'components/Field'
import InputCheckbox from 'components/InputCheckbox'
import Label from 'components/Label'
import createChainedFunction from 'utils/create-chained-function'

export default class FieldWithInput extends React.Component {
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    //input: PropTypes.node.isRequired,
    input: PropTypes.any.isRequired,
    inputProps: PropTypes.object,
    label: PropTypes.node.isRequired,
    labelAsPlaceholder: PropTypes.bool,
    labelHidden: PropTypes.bool,
    showErrorBeforeBlur: PropTypes.bool,
    validate: PropTypes.func,
    onInvalidChange: PropTypes.func,
    onValidChange: PropTypes.func,
  }

  state = {}

  componentDidMount() {
    const { inputProps } = this.props

    if (!inputProps) return

    const { defaultValue, value } = inputProps
    const initialValue = value || defaultValue

    if (initialValue) {
      this.handleChange({
        target: { value: initialValue },
      })
    }
  }

  handleBlur = (data) => {
    const { inputProps } = this.props

    this.setState({ blurred: true })

    if (inputProps && inputProps.value) {
      this.handleChange({
        target: { value: inputProps.value },
      })
    } else {
      this.handleChange(data)
    }
  }

  handleChange = (data) => {
    const { onInvalidChange, onValidChange, validate } = this.props
    let error

    if (validate) {
      try {
        validate(data)
      } catch (e) {
        error = e.message
      }
    }

    if (error && onInvalidChange) {
      onInvalidChange(data)
    } else if (!error && onValidChange) {
      onValidChange(data)
    }

    this.setState({ error })
  }

  render() {
    const {
      children,
      className,
      input,
      inputProps,
      label,
      labelAsPlaceholder,
      labelHidden,
      showErrorBeforeBlur,
    } = this.props
    const { blurred } = this.state
    let { error } = this.state

    const Component = input
    const id = uniqueId('id-')
    const isCheckbox = Component === InputCheckbox

    if (!showErrorBeforeBlur && !blurred) {
      error = null
    }

    return (
      <Field error={error} className={classNames('FieldWithInput', className)}>
        {!isCheckbox &&
          <Label hidden={labelHidden || labelAsPlaceholder} htmlFor={id}>
            {label}
          </Label>
        }
        <Component
          {...inputProps}
          id={id}
          label={isCheckbox ? label : null}
          placeholder={
            labelAsPlaceholder ?
              label :
              (inputProps && inputProps.placeholder ? inputProps.placeholder : null)
          }
          onBlur={createChainedFunction(this.handleBlur, inputProps && inputProps.onBlur)}
          onChange={createChainedFunction(this.handleChange, inputProps && inputProps.onChange)}
        />
        {children}
      </Field>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/FieldWithInput/FieldWithInput.js